// GAVION X2: objection library (dialer panel + Settings → Objections)
export const objectionsEn = {
  title: "Objections",
  panel: {
    title: "Objections",
    search: "Search an objection",
    search_hint: "O to search",
    empty: "No objection for this trade.",
    no_match: "No objection matches.",
    generic: "All trades",
    worked: "It worked",
    worked_done: "Thanks, noted!",
    worked_error: "Could not save. Try again.",
    load_error: "Could not load the objections.",
  },
  settings: {
    intro:
      "Responses suggested to reps on the call screen, filtered by the lead's trade.",
    read_only: "Read-only: only administrators edit objections.",
    new: "New objection",
    filter_trade: "Trade",
    all: "All",
    generic: "All trades (generic)",
    show_inactive: "Show inactive",
    none: "No objection.",
    edit: "Edit",
    deactivate: "Deactivate",
    reactivate: "Reactivate",
    edit_label: "Edit: %{name}",
    deactivate_label: "Deactivate: %{name}",
    reactivate_label: "Reactivate: %{name}",
    deactivated: "Objection deactivated.",
    reactivated: "Objection reactivated.",
    saved: "Objection saved.",
    save_error: "Could not save. Try again.",
    columns: {
      objection: "Objection",
      trade: "Trade",
      tags: "Tags",
      helpful: "It worked",
      order: "Order",
      status: "Status",
      actions: "Actions",
    },
    status: { active: "Active", inactive: "Inactive" },
    dialog: {
      create_title: "New objection",
      edit_title: "Edit objection",
      trade: "Trade",
      objection: "Objection (what the prospect says)",
      response: "Suggested response",
      tags: "Tags (comma-separated)",
      sort_order: "Display order",
      active: "Active",
      save: "Save",
      cancel: "Cancel",
    },
    errors: {
      required: "This field is required.",
      too_long: "Text too long.",
      invalid: "Enter a whole number.",
      too_many: "8 tags at most.",
    },
  },
};
